(function () {
  const onBlurListMenu = (header) => {
    const listMenuItems = header.querySelectorAll(
      ".list-menu--inline > .list-menu-item"
    );

    const onBlurInnerElements = () => {
      listMenuItems.forEach((item) => {
        item.querySelectorAll("a, details, summary").forEach((el) => {
          el.blur();
        });
        item.blur();
      });
    };

    listMenuItems.forEach((listMenuItem) => {
      listMenuItem.addEventListener("mouseleave", onBlurInnerElements);
    });
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const isOverlayMode = Boolean(
      header.querySelector(".header--overlay-mode")
    );
    const breadcrumbs = document.querySelector(
      ".base-breadcrumbs #breadcrumbs"
    );

    const removeColorScheme = (element) => {
      if (!element) return;
      let classNames = element.getAttribute("class");
      classNames = classNames.replace(/color-background-\d+/g, "");
      element.setAttribute("class", classNames);
    };

    if (sections.length > 0 && isOverlayMode) {
      const hasTargetSection = sections[0].classList.contains(
        "has-header-interaction"
      );
      const sectionTargetChild = sections[0].querySelector(
        "[data-header-interaction]"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );

      if (hasTargetSection && sectionTargetChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.remove("not-margin");
          header.classList.remove("not-mode");
          if (isOverlayMode) header.classList.add("overlay-mode-enabled");
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs);
            const colorScheme = sectionTargetChild.dataset.colorScheme;
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`);
          }
        } else {
          sections[0].classList.add("not-margin");
          header.classList.add("not-mode");
          header.classList.remove("overlay-mode-enabled");
          if (breadcrumbs) removeColorScheme(breadcrumbs);
        }
      } else {
        header.classList.add("not-mode");
        header.classList.remove("overlay-mode-enabled");
        if (breadcrumbs) removeColorScheme(breadcrumbs);
      }
    } else {
      header.classList.add("not-mode");
      header.classList.remove("overlay-mode-enabled");
      if (breadcrumbs) removeColorScheme(breadcrumbs);
    }

    if (header.classList.contains("overlay-mode-enabled")) {
      const headerWrapper = header.querySelector(".header-wrapper");
      if (!headerWrapper) return;

      const triggeredItems = headerWrapper.querySelectorAll(
        '.list-menu--inline > .list-menu-item[data-show-on-hover="true"]'
      );

      let removeHoverTimeout = null;
      let removeAnimateTimeout = null;

      triggeredItems.forEach((triggeredItem) => {
        triggeredItem.addEventListener("mouseenter", () => {
          if (header.classList.contains("shopify-section-header-sticky")) {
            return;
          }
          clearTimeout(removeHoverTimeout);
          clearTimeout(removeAnimateTimeout);

          headerWrapper.classList.add("hover-triggered");
          headerWrapper.classList.add("animate-triggered");
        });

        triggeredItem.addEventListener("mouseleave", () => {
          removeHoverTimeout = setTimeout(() => {
            const isStillHovered = Array.from(triggeredItems).some((el) =>
              el.matches(":hover")
            );

            if (!isStillHovered) {
              headerWrapper.classList.remove("hover-triggered");

              removeAnimateTimeout = setTimeout(() => {
                headerWrapper.classList.remove("animate-triggered");
              }, 300);
            }
          }, 0);
        });
      });
    }
  };

  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  const initMegaObserver = (header) => {
    const megaMenuLinks = header.querySelectorAll(
      ".list-menu--megamenu, .list-menu--megasubmenu"
    );
    if (!megaMenuLinks || !megaMenuLinks.length) return;

    const headerEl = header.querySelector(".header.header--has-menu");
    if (!headerEl) return;

    const calcMegaMenuPosition = () => {
      const headerRect = headerEl.getBoundingClientRect();

      const isRTL =
        document.documentElement.dir === "rtl" ||
        document.documentElement.getAttribute("dir") === "rtl";

      megaMenuLinks.forEach((link) => {
        const megaMenuEl =
          link.querySelector(".header__mega-menu") ||
          link.querySelector(".header__mega-submenu");

        if (!megaMenuEl) return;

        const linkMenuRect = link.getBoundingClientRect();

        const extraHeight = Math.abs(linkMenuRect.bottom - headerRect.bottom);
        const extraHeightFix = Math.ceil(extraHeight * 100) / 100;

        let extraLeft;
        if (isRTL) {
          // зеркальная логика для RTL
          extraLeft = (headerRect.right - linkMenuRect.right - 20).toFixed(2);
        } else {
          extraLeft = (linkMenuRect.left - headerRect.left - 20).toFixed(2);
        }

        const extraWidth = (linkMenuRect.width + 30).toFixed(2);

        megaMenuEl.style.setProperty("--extra-height", `${extraHeightFix}px`);
        megaMenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        megaMenuEl.style.setProperty("--extra-width", `${extraWidth}px`);

        let maxCollectionHeight = 0;
        megaMenuEl.querySelectorAll(".collection-card").forEach((el) => {
          const collectionHeight = el.scrollHeight + 24;
          maxCollectionHeight = Math.max(maxCollectionHeight, collectionHeight);
        });

        if (maxCollectionHeight > 264) {
          megaMenuEl.style.maxHeight = `${maxCollectionHeight}px`;
        }
      });
    };

    const observer = new ResizeObserver(() => {
      calcMegaMenuPosition();
    });

    observer.observe(header);
  };

  const initSubmenuObserver = (header) => {
    const submenus = header.querySelectorAll(".list-menu--submenu");
    if (!submenus.length) return;

    const headerEl = header.querySelector(".header.header--has-menu");
    if (!headerEl) return;

    const calcSubmenuPosition = () => {
      const headerRect = headerEl.getBoundingClientRect();

      const isRTL =
        document.documentElement.dir === "rtl" ||
        document.documentElement.getAttribute("dir") === "rtl";

      submenus.forEach((submenu) => {
        const wrapper = submenu.querySelector(".mega-submenu__wrapper");
        const headerSubmenu = submenu.querySelector(".header__submenu");
        if (!wrapper) return;

        const submenuRect = submenu.getBoundingClientRect();

        let extraLeft;
        const extraHeight = Math.abs(submenuRect.bottom - headerRect.bottom);
        const extraHeightFix = Math.ceil(extraHeight * 100) / 100;
        const extraWidth = (submenuRect.width + 30).toFixed(2);

        if (isRTL) {
          extraLeft = (headerRect.right - submenuRect.right).toFixed(2);
        } else {
          extraLeft = (submenuRect.left - headerRect.left).toFixed(2);
        }

        wrapper.style.setProperty("--extra-left", `${extraLeft}px`);
        headerSubmenu.style.setProperty("--extra-left", `${extraLeft}px`);
        headerSubmenu.style.setProperty(
          "--extra-height",
          `${extraHeightFix}px`
        );
        headerSubmenu.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver(() => {
      calcSubmenuPosition();
    });

    observer.observe(header);

    // первый расчёт
    calcSubmenuPosition();
  };

  const initDynamicLogo = (header) => {
    const headerEl = header.querySelector(".header--dynamic-mode");
    if (!headerEl) return;

    const stickyHeader = header.querySelector("[data-sticky-type]");
    if (
      !stickyHeader ||
      stickyHeader.getAttribute("data-sticky-type") !== "always"
    )
      return;

    const logoHeading = headerEl.querySelector("[data-dynamic-logo]");
    if (!logoHeading) return;

    const logoLink = logoHeading.querySelector(".header__heading-link");
    if (!logoLink) return;

    const spacer = headerEl.querySelector("[data-dynamic-spacer]");
    if (!spacer) return;

    const dynamicWidth = parseFloat(logoHeading.dataset.dynamicWidth || 160);
    const logoWidth = parseFloat(logoHeading.dataset.logoWidth || 100);
    const logoWidthMobile = parseFloat(
      logoHeading.dataset.logoWidthMobile || 100
    );

    const BREAKPOINT_DESKTOP = 990;

    let startTranslateY = 0;
    let cachedNaturalWidth = 0;
    let cachedNaturalHeight = 0;

    const cacheLayout = () => {
      logoLink.style.transform = "";
      spacer.style.height = "";

      const rect = logoLink.getBoundingClientRect();
      cachedNaturalWidth = rect.width;
      cachedNaturalHeight = rect.height;
      if (rect.width <= 0) return;

      // Logo is centered in the spacer (naturalHeight + 20px), 10px gap each side
      startTranslateY = cachedNaturalHeight + 10;
      spacer.style.height = `${cachedNaturalHeight + 20}px`;
    };

    const update = () => {
      const isMobile = window.innerWidth < BREAKPOINT_DESKTOP;
      const targetWidth = isMobile ? logoWidthMobile : logoWidth;
      // Use measured width so CSS max-width constraints are accounted for
      const endScale = targetWidth / cachedNaturalWidth;

      const scrollThreshold = window.innerHeight * 0.5;
      const linearProgress = Math.min(
        Math.max(window.scrollY / scrollThreshold, 0),
        1
      );
      // Ease-in-out
      const progress =
        linearProgress < 0.5
          ? 2 * linearProgress * linearProgress
          : 1 - Math.pow(-2 * linearProgress + 2, 2) / 2;

      const currentScale = 1 + (endScale - 1) * progress;
      const currentTranslateY = startTranslateY * (1 - progress);
      logoLink.style.transform = `translateY(${currentTranslateY}px) scale(${currentScale})`;

      // Spacer tracks how far the logo visually extends below its layout row
      const overflow =
        currentTranslateY + (cachedNaturalHeight * (currentScale - 1)) / 2;
      spacer.style.height =
        linearProgress >= 1 ? "0px" : `${Math.max(0, overflow + 10)}px`;
    };

    cacheLayout();
    update();

    let rafId = null;
    const scheduleUpdate = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        update();
      });
    };

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener(
      "resize",
      () => {
        cacheLayout();
        update();
      },
      { passive: true }
    );
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    onBlurListMenu(header);
    initHeaderOverlay(header);
    initMegaObserver(header);
    initMegaSubmenu(header);
    initSubmenuObserver(header);
    initDynamicLogo(header);
  };

  initHeader();

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

if (!customElements.get("burger-menu")) {
  customElements.define(
    "burger-menu",
    class BurgerMenu extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
        this.burgerMenu = this.querySelector(".burger-menu");
        this.openButton = this.querySelector(".burger-menu__toggle");
        this.closeButton = this.querySelector(".modal-close-button");
        this.overlayEl = this.querySelector(".modal__overlay");

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.handleKeyDown = this.onHandleKeyDown.bind(this);
      }

      connectedCallback() {
        this.openButton?.addEventListener("click", this.open);
        this.closeButton?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);
        this.header?.addEventListener("keydown", this.handleKeyDown);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener("click", this.open);
        this.closeButton?.removeEventListener("click", this.close);
        this.overlayEl?.removeEventListener("click", this.close);
        this.header?.removeEventListener("keydown", this.handleKeyDown);
      }

      onOpen() {
        if (this.header) this.header.preventHide = true;

        const headerSearch = document.querySelector("header-search[open]");
        if (headerSearch && typeof headerSearch.onClose === "function") {
          headerSearch.onClose();
        }

        this.setAttribute("open", true);
        this.burgerMenu.classList.add("modal--open");
        document.body.classList.add("overflow-hidden-desktop-menu");

        this.addEventListener(
          "transitionend",
          () => {
            trapFocus(
              this.burgerMenu,
              this.burgerMenu.querySelector('[role="dialog"]')
            );
          },
          { once: true }
        );
      }

      onClose() {
        document.body.classList.remove("overflow-hidden-desktop-menu");
        document.body.classList.remove("overflow-hidden");
        this.removeAttribute("open");
        this.burgerMenu.classList.remove("modal--open");
        removeTrapFocus(this.openButton);
        this.querySelectorAll("menu-drawer").forEach((submenu) => {
          if (submenu && typeof submenu.closeMenuDrawer === "function") {
            submenu.closeMenuDrawer(this.openButton);
          }
        });
        if (this.header) this.header.preventHide = false;
      }

      onHandleKeyDown(event) {
        if (this.getAttribute("open")) {
          if (event.key === "Escape") {
            this.close();
          }
        }
      }
    }
  );
}

if (!customElements.get("header-search")) {
  customElements.define(
    "header-search",
    class HeaderSearch extends HTMLElement {
      constructor() {
        super();
        this.header = document.querySelector(".header-wrapper");
        this.searchLink = this.querySelector(".header__button--search");
        this.modalContainer = this.querySelector(".header__search-modal");
        this.closeButton =
          this.querySelector(".modal-close-button") ||
          this.querySelector(".mobile-submenu__back");
        this.overlayEl = this.querySelector(".modal__overlay");
        this.searchButton = this.querySelector(".search__button");
        this.location = this.dataset.location;

        this.searchInput = this.querySelector(
          "#Search-In-Modal, #Search-In-Modal-Mobile"
        );

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.handleKeyDown = this.onHandleKeyDown.bind(this);
      }

      connectedCallback() {
        //this.searchLink?.addEventListener("click", this.open);
        this.searchLink?.addEventListener("click", this.onToggle.bind(this));
        this.closeButton?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);
        this.header?.addEventListener("keydown", this.handleKeyDown);

        this.setTimeout = null;
      }

      disconnectedCallback() {
        this.searchLink?.removeEventListener("click", this.open);
        this.closeButton?.removeEventListener("click", this.close);
        this.overlayEl?.removeEventListener("click", this.close);
        this.header?.removeEventListener("keydown", this.handleKeyDown);
      }

      onToggle(event) {
        event.preventDefault();

        if (this.hasAttribute("open")) {
          this.close();
        } else {
          this.open(event);
        }
      }

      onOpen(event) {
        event.preventDefault();
        this.setTimeout && window.clearTimeout(this.setTimeout);
        if (this.header) this.header.preventHide = true;
        this.setAttribute("open", true);
        this.modalContainer.classList.add("modal--open");

        if (this.header) {
          this.header.preventHide = true;
          this.header.classList.add("hover-triggered");
          this.header.classList.add("animate-triggered");
        }

        this.addEventListener(
          "transitionend",
          () => {
            trapFocus(
              this.modalContainer,
              this.modalContainer.querySelector('[role="dialog"]')
            );
          },
          { once: true }
        );

        //// transition duration in modal 300ms
        //if (this.searchInput && navigator.userAgent.indexOf("iPhone") === -1) {
        //  this.setTimeout = setTimeout(() => this.searchInput.focus(), 500);
        //}

        if (this.location === "desktop-header") {
          document.body.classList.add("overflow-hidden-laptop");
        }
      }

      onClose() {
        this.setTimeout && window.clearTimeout(this.setTimeout);
        this.removeAttribute("open");
        this.modalContainer.classList.remove("modal--open");

        if (this.header) {
          this.header.preventHide = false;
          setTimeout(() => {
            this.header.classList.remove("hover-triggered");
            this.header.classList.remove("animate-triggered");
          }, 300);
        }

        if (this.location === "desktop-header") {
          document.body.classList.remove("overflow-hidden-laptop");
        }

        removeTrapFocus(this.searchLink);

        if (this.header) this.header.preventHide = false;
        const parentMenu = this.closest("header-drawer");
        if (!parentMenu) removeTrapFocus(this.searchLink);
        if (parentMenu) {
          removeTrapFocus(parentMenu.closeBtn);
          const parentOpenScrollY = parentMenu.openScrollY || 0;
          window.scrollTo(0, parentOpenScrollY);
        }
      }

      onHandleKeyDown(event) {
        if (this.getAttribute("open")) {
          if (event.key === "Escape") {
            this.close();
          }
        }
      }
    }
  );
}

function initCollapsibleIcons() {
  const btn = document.querySelector(".header-icons-collapsible-btn");
  const content = document.querySelector(".header-icons-collapsible-content");
  if (!btn || !content) return;

  btn.addEventListener("click", () => {
    const expanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", !expanded);
    content.classList.toggle("open");

    if (expanded) {
      btn.classList.remove("animationEffect");
      btn.classList.add("reversedAnimationEffect");
    } else {
      btn.classList.add("animationEffect");
      btn.classList.remove("reversedAnimationEffect");
    }
  });
}

initCollapsibleIcons();

document.addEventListener("shopify:section:load", initCollapsibleIcons);

const burgerSlider = new Swiper(".burger-menu__collections", {
  direction: "vertical",
  slidesPerView: "auto",
  spaceBetween: 2,
  speed: 600,
  watchSlidesProgress: true,
  resistanceRatio: 0,
  observer: true,
  observeParents: true,

  mousewheel: {
    enabled: true,
    forceToAxis: true,
    sensitivity: 0.5,
    thresholdDelta: 30,
    thresholdTime: 300,
    releaseOnEdges: true,
  },

  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },

  on: {
    progress(swiper) {
      swiper.slides.forEach((slide) => {
        const progress = slide.progress;

        slide.style.zIndex = 10 - Math.abs(Math.round(progress));
      });
    },

    setTransition(swiper, speed) {
      swiper.slides.forEach((slide) => {
        slide.style.transition = `${speed}ms`;
      });
    },
  },
});
